module.exports = __webpack_public_path__ + "img/6.44d942d9.png";